var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"SKU View"}},[_c('div',{staticClass:"vx-input-group flex"},[_c('vs-tabs',{attrs:{"value":_vm.activeTab}},[_c('vs-tab',{attrs:{"label":"Data"}},[_c('tab-data')],1),_c('vs-tab',{attrs:{"label":"Export"}},[_c('tab-export')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }